import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'components/modals';
import {t} from 'shared/core';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';

const LiabilityCalculationModal = observer(({isOpen, uiState}) => {
  const {selectedLiabilityBalance, liabilityTypePolicy} = uiState;

  return (
    <Modal
      title={t('employees.profile.time_off.liability.LIABILITY_CALCULATION_TITLE', { typeName: _.get(selectedLiabilityBalance, 'type.name') })}
      description={_.get(liabilityTypePolicy, 'accrueUpfront') ? 'employees.profile.time_off.liability.LIABILITY_EXPLAINER_UPFRONT' : 'employees.profile.time_off.liability.LIABILITY_EXPLAINER_END_OF_PERIOD'}
      isOpen={isOpen}
      onHide={() => uiState.closeLiabilityCalculationModal()}
      size='md'
    >
      <div className='flex mb1'>
        <div className='col-1'></div> 
        <div className='col-11'>
          {selectedLiabilityBalance.availableView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.available'/>
          </span>
        </div>
      </div>
      <div className='flex mb1'>
        <div className='col-1'>{selectedLiabilityBalance.accrualAdjustment < 0 ? '-' : '+'}</div> 
        <div className='col-11'>
          {selectedLiabilityBalance.absoluteAccrualAdjustmentView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.ACCRUAL_ADJUSTMENT_PERIOD' values={{range: selectedLiabilityBalance.accrualAdjustmentPeriodDateRange}}/>
          </span>
        </div>
      </div>
      {selectedLiabilityBalance.scheduled > 0 && <div className='flex mb1'>
        <div className='col-1'>{'+'}</div> 
        <div className='col-11'>
          {selectedLiabilityBalance.scheduledView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.SCHEDULED_TIME_OFF' values={{date: selectedLiabilityBalance.lastDayOfWorkView}}/>
          </span>
        </div>
      </div>}
      <hr className='my1 border--whale'/>
      <div className='flex'>
        <div className='col-1'></div> 
        <div className='col-11'>
          {selectedLiabilityBalance.totalLiabilityView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.final balance'/>
          </span>
        </div>
      </div>
    </Modal>
  );
});

export default LiabilityCalculationModal;
